// extracted by mini-css-extract-plugin
module.exports = {"imgNav":"Navbar_imgNav__gqCq6","navText":"Navbar_navText__TLpPc","navLogo":"Navbar_navLogo__3EtbV","imgLogo":"Navbar_imgLogo__71erg"};